import { getIndexByEntityId } from 'utils/clickme';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import Header from 'components/Admin/Invoices/InvoicesTable/Header';
import Invoice from 'components/Admin/Invoices/InvoicesTable/Invoice';
import Spinner from 'components/Admin/Spinner';
import TableBody from 'components/Table/TableBody';
import TableHead from 'components/Table/TableHead';

import { useSelector } from 'store/utils';

import 'components/Admin/Invoices/InvoicesTable/InvoicesTable.less';

const InvoicesTable = () => {
    const { invoices, isLoad, accounts, showGiftButton } = useSelector((state) => state.invoices);

    const trl = useTrls();

    if (isLoad) {
        return <Spinner />;
    }
    if (invoices.length === 0) {
        return <div>{trl('admin.Invoices.InvoicesTable.empty')}</div>;
    }
    return (
        <div>
            <p className="invoices-table-total">{trl('admin.Invoices.InvoicesTable.total', [invoices.length])}</p>
            <Table className="invoices-table" bordered withStripes>
                <TableHead>
                    <Header />
                </TableHead>
                <TableBody>
                    {invoices.map((invoice) => {
                        const accountKey = getIndexByEntityId(invoice.accountId, accounts, 'id');
                        return (
                            <Invoice
                                key={invoice.id}
                                {...invoice}
                                account={accounts[accountKey]}
                                showGiftButton={showGiftButton}
                            />
                        );
                    })}
                </TableBody>
            </Table>
        </div>
    );
};

export default InvoicesTable;
